import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContextMenu } from 'sharedComponents';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router';
import useHeaderMenus from './useHeaderMenus';
import { getAssetIcon } from 'helpers/icons';
import { actionTypes, assetMenuItems } from './constants';
import { actionTypes as dataLoggerActionTypes } from './DataLogger/constants';
import { apiCallStatus, gatewayTypes, NotificationTypeCode } from 'helpers/constants';
import isEmpty from 'lodash/isEmpty';
import { ReportGenerator } from '../../../Reports/ReportGenerator';

import './style.scss';

const HeaderComponent = (props) => {
    const { asset, selectedNotification, nameplatePicturesLoadingStatus, showLegacyDetails = true } = props;
    const assetId = asset?.id;
    const { dataLoggerCommands, selectedAssetType } = useSelector((state) => ({
        dataLoggerCommands: state?.dataLoggerCommands?.loggerCommandsList,
        selectedAssetType: state?.detailedInformation.assetDetails?.data?.details?.sensorType,
    }));

    const dispatch = useDispatch();
    const history = useHistory();
    const [headerMenus, selectedHeaderMenu] = useHeaderMenus(asset?.componentType?.typeName, asset, dataLoggerCommands, selectedAssetType);

    useEffect(() => {
        if (asset?.gatewayType === gatewayTypes.NETA21 || asset?.gatewayType === gatewayTypes.EGW02) {
            dispatch({ type: dataLoggerActionTypes.GET_DATA_LOGGER_COMMANDS_REQUEST, assetId });
        }
        return () => dispatch({ type: actionTypes.CLEAR_STORE });
    }, [asset?.id]);

    useEffect(() => {
        if (selectedHeaderMenu?.menuAction) {
            selectedHeaderMenu.menuAction(dispatch, history, asset);
            dispatch({ type: actionTypes.SELECT_MENU_ITEM, selectedMenuItem: null });
        }
    }, [selectedHeaderMenu]);

    const toggleSelection = (selectedMenuItemId) => {
        dispatch({ type: actionTypes.SELECT_MENU_ITEM, selectedMenuItem: selectedMenuItemId });
        dispatch({ type: actionTypes.CLOSE_DIALOGUE, data: { reName: null } });
    };

    // OPEN CHANGED_PARAMETER_LIST_V2 MODAL WHEN NOTIFICATION IS CLICKED
    useEffect(() => {
        if (selectedNotification && (nameplatePicturesLoadingStatus === apiCallStatus.SUCCESS || nameplatePicturesLoadingStatus === apiCallStatus.ERROR)) {
            if (selectedNotification?.notificationTypeCode === NotificationTypeCode.AssetNameplatePropertyChanged || selectedNotification?.notificationTypeCode === NotificationTypeCode.ParameterChanged) {
                const changedParametersListV2 = headerMenus?.find((hm) => hm?.id === assetMenuItems.CHANGED_PARAMETER_LIST_V2);
                if (changedParametersListV2 && !changedParametersListV2?.hidden) {
                    toggleSelection(assetMenuItems.CHANGED_PARAMETER_LIST_V2);
                }
            }
        }
    }, [selectedNotification, headerMenus, nameplatePicturesLoadingStatus]);

    const renderContextMenu = () => {
        return !isEmpty(headerMenus) && <ContextMenu id='headingContextMenu'
            options={headerMenus}
            onSelect={toggleSelection} />;
    };

    return <>
        {showLegacyDetails ?
            <Container className='detailed-information-header' fluid>
                <Row className='asset-information'>
                    {showLegacyDetails && <>
                        <Col md='auto'>{getAssetIcon(asset?.assetType, { width: '24', height: '24' })}</Col>
                        <Col className='asset-name'>{asset?.name}</Col>
                    </>}
                    <Col md='auto'>
                        {
                            //asset?.isUserAccessible &&
                            renderContextMenu()
                        }
                    </Col>
                </Row>
            </Container> : renderContextMenu()}
        {
            selectedHeaderMenu?.modalContentComponent &&
            <selectedHeaderMenu.modalContentComponent
                show={!!selectedHeaderMenu}
                close={() => toggleSelection(null)}
                title={selectedHeaderMenu.title}
                asset={asset}
            />
        }
        <ReportGenerator />
    </>;
};
HeaderComponent.propTypes = {
    asset: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        componentType: PropTypes.shape({
            typeName: PropTypes.string
        }),
        gatewayType: PropTypes.string,
        assetType: PropTypes.string
    }),
    selectedNotification: PropTypes.shape({
        notificationTypeCode: PropTypes.string
    }),
    nameplatePicturesLoadingStatus: PropTypes.string,
    showLegacyDetails: PropTypes.bool
};
export default HeaderComponent;
